/*@flow*/

export default (prefix: string): RegExp => new RegExp(`^${prefix}`);
